import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectTeamRetrieveInterface } from "../../../middleware/interfaces/project/project-team-retrieve-interface";

export const ProjectTeamRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const ProjectTeamRetrieveData: ProjectTeamRetrieveInterface = state.data;
      const url = "./php/project/project-team-retrieve-proxy.php";
      await axios
        .post(url, ProjectTeamRetrieveData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
